export enum VisualizacaoEnum {
    INTERNA,
    EXTERNA
}
